import React, { FC, useState } from "react";

import { Button, Divider } from "antd";
import ApplicationDetailsDoсSection from "./ApplicationDetailsDoсSection/ApplicationDetailsDoсSection";
import { useParams } from "react-router-dom";
import { useGetApplicationDataToBankQuery } from "../../../../store/api/applicationBankApi/applicationBank.api";
import { OfferDocListSection } from "./OfferDocList/OfferDocListSection";
import { applicationBankDocumentsApi } from "../../../../services/documents/documents.api";
import ApplicationDetailsAdditionalDoсSection from "../ApplicationDetailsAdditionalDocSection/ApplicationDetailsAdditionalDocSection";

interface ApplicationDetailsDoсListProps {
  className?: string;
}

const { downloadAllDocuments } = applicationBankDocumentsApi;

export const ApplicationDetailsDoсList: FC<
  ApplicationDetailsDoсListProps
> = () => {
  const { applicationBankId } = useParams();

  const [isDownloadingAllDocuments, setIsDownloadingAllDocuments] =
    useState(false);

  const { data: applicationBankData } = useGetApplicationDataToBankQuery(
    Number(applicationBankId)
  );

  const passportDocument = applicationBankData?.documents.pasportDocument;
  const mainDocument = applicationBankData?.documents.mainDocument;
  const financeDocument = applicationBankData?.documents.financeDocument;
  const additionalDocument = applicationBankData?.documents.additionalDocument;
  const banksOfferDocuments =
    applicationBankData?.documents.banksOfferDocuments;

  const handleDownloadAllDocuments = async () => {
    setIsDownloadingAllDocuments(true);
    await downloadAllDocuments({
      applicationBankId: Number(applicationBankId),
      organizationName:
        applicationBankData?.application.organization.name || "",
      organizationINN: applicationBankData?.application.organization.inn || "",
    });
    setIsDownloadingAllDocuments(false);
  };

  return (
    <div
      style={{
        paddingBottom: "24px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {banksOfferDocuments && banksOfferDocuments.documents && (
        <>
          <Divider orientation="left" orientationMargin="0">
            {banksOfferDocuments.title}
          </Divider>
          <OfferDocListSection documents={banksOfferDocuments.documents} />
        </>
      )}
      {passportDocument && passportDocument.documents && (
        <>
          <Divider orientation="left" orientationMargin="0">
            {passportDocument.title}
          </Divider>
          <ApplicationDetailsDoсSection
            documents={passportDocument.documents}
          />
        </>
      )}
      {mainDocument && mainDocument.documents && (
        <>
          <Divider orientation="left" orientationMargin="0">
            {mainDocument.title}
          </Divider>
          <ApplicationDetailsDoсSection documents={mainDocument.documents} />
        </>
      )}
      {financeDocument && financeDocument.documents && (
        <>
          <Divider orientation="left" orientationMargin="0">
            {financeDocument.title}
          </Divider>
          <ApplicationDetailsDoсSection documents={financeDocument.documents} />
        </>
      )}
      {additionalDocument && additionalDocument.documents && (
        <>
          <Divider orientation="left" orientationMargin="0">
            {additionalDocument.title}
          </Divider>
          <ApplicationDetailsAdditionalDoсSection
            documents={additionalDocument.documents}
          />
        </>
      )}
      <Button
        type="primary"
        style={{ marginLeft: "auto" }}
        onClick={handleDownloadAllDocuments}
        loading={isDownloadingAllDocuments}
      >
        Скачать все документы
      </Button>
    </div>
  );
};
